// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__4pr8p","actions":"GroupTable_actions__6ghOs","deleteModalFooter":"GroupTable_deleteModalFooter__2Qg-t"};